import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { SkillFullFragment, SKILL_FULL_FRAGMENT } from "../../fragments";
import { SkillsQueryVariables } from "../../types";

export const GET_SKILLS = gql`
  query getSkills(
    $q: String
    $locale: String
    $page: Int
    $per: Int
    $havingReportAnswers: Boolean
    $campaignId: ID
  ) {
    skills(
      q: $q
      locale: $locale
      page: $page
      per: $per
      havingReportAnswers: $havingReportAnswers
      campaignId: $campaignId
    ) {
      collection {
        ...SkillFullFragment
      }
    }
  }
  ${SKILL_FULL_FRAGMENT}
`;

export type SkillsAnalyticsData = { skills: { collection: SkillFullFragment[] } };

export default (
  options?: QueryHookOptions<SkillsAnalyticsData, SkillsQueryVariables>
) => {
  return useQuery<SkillsAnalyticsData, SkillsQueryVariables>(GET_SKILLS, options);
};
